module.exports = __webpack_public_path__ + "img/crown.f58befae.svg";